import { smoothScrollTo } from "@utils";
import { BetterButtonProps, BetterButton } from "components/atoms/BetterButton";
import Link from "next/link";
import { FC } from "react";
import { useAdminContext } from "react-bricks/frontend";

type Props = BetterButtonProps & {
  href: string;
};

const Button: FC<Props> = ({ href, ...props }) => {
  const { isAdmin } = useAdminContext();

  if (isAdmin) {
    return <BetterButton {...props} />;
  }

  if (href?.startsWith("#")) {
    return <BetterButton onClick={() => smoothScrollTo(window, href.slice(1), -100)} {...props} />;
  }

  return (
    <Link href={href}>
      <BetterButton {...props} />
    </Link>
  );
};

export default Button;
